import { z } from 'zod'
import { firestoreTimestamp, firestoreWriteTimestamp } from '../shared/schema'

export const schema = z.object({
  productId: z.string(),
  creatorUserId: z.string(),
  expiresAt: firestoreTimestamp,
  productName: z.string(),
  productType: z.string(),
  sectionPassQuantity: z.number().int(),
  sectionPassPrice: z.number().int(),
  userId: z.string(),
  updatedAt: firestoreTimestamp,
})

export const writeSchema = schema.extend({
  expiresAt: firestoreWriteTimestamp,
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(
  schema.parse({
    productId: '',
    expiresAt: { seconds: 0, nanoseconds: 0 },
    creatorUserId: '',
    productName: '',
    productType: '',
    sectionPassQuantity: 0,
    sectionPassPrice: 0,
    userId: '',
    updatedAt: { seconds: 0, nanoseconds: 0 },
  })
)

export type FirestoreUserProfileCustomProduct = z.infer<typeof schema>
export type FirestoreUserProfileCustomProductWrite = z.infer<typeof writeSchema>
